import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Gift, Pizza, Beef } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = "/logo.png";

const rewards = [
  { id: 'pizza_marinara', name: 'Pizza Marinara', icon: Pizza, type: 'pizza' },
  { id: 'pizza_margherita', name: 'Pizza Margherita', icon: Pizza, type: 'pizza' },
  { id: 'classic_burger', name: 'Classic Burger', icon: Beef, type: 'burger' },
];

const LoyaltyRewardModal = ({ isOpen, onClose, onSelect }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selected) {
      onSelect(selected);
      onClose();
    }
  };

  const handleSkip = () => {
    onSelect(null);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center" data-testid="loyalty-reward-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={handleSkip} />
      <div className="relative w-[95%] max-w-md bg-[#141417] border border-zinc-700 rounded-2xl overflow-hidden shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="h-1.5 bg-gradient-to-r from-[#FFC107] via-[#FFD54F] to-[#FFC107]" />
        <div className="p-6 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#FFC107]/15 mb-4">
            <Gift className="h-8 w-8 text-[#FFC107]" />
          </div>
          <h2 className="text-xl font-bold text-white font-['Barlow_Condensed'] uppercase tracking-wide">
            {t('loyalty.congratulations')}
          </h2>
          <p className="text-zinc-400 text-sm mt-2">
            {t('loyalty.rewardMessage')}
          </p>
        </div>

        {/* Reward Options */}
        <div className="px-6 pb-4 space-y-2">
          {rewards.map((reward) => {
            const Icon = reward.icon;
            const isSelected = selected === reward.id;
            return (
              <button
                key={reward.id}
                onClick={() => setSelected(reward.id)}
                className={`w-full flex items-center gap-4 p-4 rounded-xl border-2 transition-all duration-200 ${
                  isSelected
                    ? 'border-[#FFC107] bg-[#FFC107]/10 shadow-[0_0_12px_rgba(255,193,7,0.15)]'
                    : 'border-zinc-700 bg-[#1C1C22]/50 hover:border-zinc-600'
                }`}
                data-testid={`reward-option-${reward.id}`}
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                  isSelected ? 'bg-[#FFC107]/20' : 'bg-zinc-700/50'
                }`}>
                  <Icon className={`h-5 w-5 ${isSelected ? 'text-[#FFC107]' : 'text-zinc-400'}`} />
                </div>
                <div className="flex-1 text-left">
                  <p className={`font-semibold ${isSelected ? 'text-[#FFC107]' : 'text-white'}`}>{reward.name}</p>
                  <p className="text-xs text-zinc-500">{t('loyalty.freeItem')}</p>
                </div>
                {isSelected && (
                  <img src={LOGO_URL} alt="" className="h-6 w-6 opacity-80" />
                )}
              </button>
            );
          })}
        </div>

        {/* Actions */}
        <div className="p-6 pt-2 flex gap-3">
          <Button
            variant="outline"
            className="flex-1 border-zinc-700 hover:bg-[#25252E] text-zinc-400"
            onClick={handleSkip}
            data-testid="loyalty-skip-btn"
          >
            {t('loyalty.skipReward')}
          </Button>
          <Button
            className="flex-1 bg-[#FFC107] text-black hover:bg-[#F59E0B] font-bold disabled:opacity-40"
            onClick={handleConfirm}
            disabled={!selected}
            data-testid="loyalty-confirm-btn"
          >
            {t('loyalty.claimReward')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyRewardModal;
